<template>
  <div class="Menus">
    <div class="Menus_notice" style="padding: 10px">
      <van-button type="info" size="mini" style="width: 100%" @click="AddBarIndex">保存</van-button>
    </div>
    <div class="Menus_notice hiddenScroll" style="overflow: auto; min-height: 50px" v-for="(item, index) in menuData"
      :key="index">
      <div class="notice_title" style="align-items: center">
        <div class="MarginR10">
          <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.5" cx="5" cy="5" r="5" fill="#033C88" />
            <circle cx="12" cy="5" r="5" fill="#033C88" />
          </svg>
        </div>
        <div class="flexLR" style="width: 100%">
          <div>{{ item.authName }}</div>
          <div></div>
        </div>
      </div>
      <div class="flexWrap" style="overflow: auto; width: 100%">
        <div class="menuItemStyle" style="margin: 20px 0; position: relative" v-for="(chItem, index) in item.children"
          :key="index">
          <img src="../../../assets/mobileImg/jia.png" alt="" width="16" v-if="!chItem.IsShowMenu"
            style="position: absolute; right: 5px; top: -10px; z-index: 999" @click="setTempIds(chItem)" />
          <img src="../../../assets/mobileImg/_.png" alt="" width="16" v-else
            style="position: absolute; right: 5px; top: -10px; z-index: 999" @click="setTempIds(chItem)" />
          <div class="flexLR" v-if="chItem.children && chItem.children.length > 0">
            <div class="menuItemStyle" style="margin: 15px 0; overflow: auto" v-for="(el, index) in chItem.children"
              :key="index">
              <div>
                <div>
                  <!-- <img src="../../../assets/mobileImg/进度上报.png" alt="" /> -->
                  <!-- <img :src="chItem.src" @error="imgError($event)" alt="" /> -->
                  <img :src="`img/6.0/${el.authName}.png`" alt="" />
                </div>
                <div class="nowrap">{{ el.authName }}</div>
              </div>
            </div>
          </div>
          <div v-else style="position: relative">
            <div>
              <!-- <img src="../../../assets/mobileImg/进度上报.png" alt="" /> -->
              <!-- <img :src="chItem.src" @error="imgError($event)" alt="" /> -->
              <img :src="`img/6.0/${chItem.authName}.png`" alt="" />
            </div>
            <div class="nowrap">{{ chItem.authName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetFunctionTemplate, AddBarIndex, GetBarIndex } from "@/api/index";
export default {
  name: "Menus",
  components: {},
  data() {
    return {
      upDateHomeMenu: false,
      menuData: [],
      Menulist: [
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
        {
          title: "进度上报",
          icon: require("../../../assets/mobileImg/进度上报.png"),
          path: "/home/menu/MenuTemplate",
        },
      ],
      tempIds: [],
      UserTempIds: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    imgError(event) {
      let img = event.srcElement;
      img.src = "../../../assets/6/安全方案报审.png";
      img.onerror = null; //防止闪
    },
    openMenuTemplate(item) {
      this.$router.push({
        name: "MenuTemplate",
        query: {
          key: JSON.stringify({ type: item.fctm01, name: item.fctm02 }),
        },
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        item.id = `Tree${item[idName]}`;
        item.authName = item.fctm02;
        item.src = "../../../assets/6/" + item.fctm02.trim() + ".png";
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        item["path"] = "MenuTemplate";
        item["IsShowMenu"] = this.UserTempIds.split(",").some(
          (el) => el == item.fctm01
        );
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          (item["icon"] = "el-icon-star-on"), result.push(item);
        }
      });
      return result;
    },
    GetFunctionTemplate() {
      GetFunctionTemplate({ params: { xid: localStorage.xid } }).then((res) => {
        this.menuData = [];
        var dataMenu = this.getTreeDate(
          res.Data.projectfunctiontemplates,
          "fctm01",
          "fctm03"
        );
        this.menuData = this.menuData.concat(dataMenu);
      });
    },
    AddBarIndex() {
      AddBarIndex({
        xid: this.$store.state.pid,
        uid: this.$store.state.uid,
        tempIds: this.tempIds.toString(),
      }).then((res) => {
        this.$Toast("成功");
        this.tempIds = [];
        this.$router.go(-1);
      });
    },
    setTempIds(item) {
      item.IsShowMenu = !item.IsShowMenu;
      if (item.IsShowMenu) {
        this.tempIds.push(item.fctm01 + "");
      } else {
        this.tempIds = this.tempIds.filter((el) => el != item.fctm01);
      }
    },
    GetBarIndex() {
      GetBarIndex({
        params: {
          xid: this.$store.state.pid,
          uid: this.$store.state.uid,
        },
      }).then((res) => {
        this.UserTempIds = res.Data.model ? res.Data.model.baid04 : "";
        this.tempIds = res.Data.model && res.Data.model.baid04 != '' ? res.Data.model.baid04.split(",") : [];
        this.GetFunctionTemplate();
      });
    },
  },
  created() {
    this.GetBarIndex();
  },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.Menus {
  margin: 0 auto;
  padding: 0 40px;

  .Menus_notice {
    width: 100%;
    height: 40%;
    background: #fff;
    margin: 20px 0;
    padding: 0 40px;
    border-radius: 5px;

    .notice_title {
      padding-top: 20px;
      display: flex;
      width: 100%;
      height: 60px;
      line-height: 50px;
    }
  }

  .menuItemStyle {
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;
    background: #fff;
  }
}

.MarginR10 {
  margin-right: 10px;
}
</style>
